import React, { useRef, useEffect, useContext } from 'react';
import { FaPrint } from "react-icons/fa";
import { ApiLink } from '../APILink/ApiLink';
import JsBarcode from 'jsbarcode';
import { AddActionsButton } from '../Components/AddElementsButton';
import { FiscalYearContext } from '../FiscalYear/FiscalYearContext';


const PrintCreditNote = ({ data, clientData, companyData, formType, hasElectronicSeal, bankaccounts }) => {
    const { fiscalYear } = useContext(FiscalYearContext);

    const barcodeRef = useRef(null);

    const date = data.Date || "";
    const invoiceNR = data.InvoiceNr || "";
    const amount0 = data.Amount0 || 0.00;
    const amount8 = data.Amount8 || 0.00;
    const amount18 = data.Amount18 || 0.00;
    // const vat8 = data.VAT8 || 0.00;
    const vat8 = Number(data.Amount8) * (Number(8) / Number(100)) || 0.00;
    // const vat18 = data.VAT18 || 0.00;
    const vat18 = Number(data.Amount18) * (Number(18) / Number(100)) || 0.00;
    const comment = data.Coment || "";
    const user = data.ModifiedByUser || "";

    // const vatTotal = Number(withoutVAT) * (Number(vat) / Number(100));



    const formatDate = (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0'); // +1 sepse muajt fillojnë nga 0
        const year = d.getFullYear();
        return `${day}.${month}.${year}`;
    };
    const printElectronicSeal = hasElectronicSeal ? hasElectronicSeal : false;

    const vat8Calculation = (Number(amount8) + Number(vat8));
    const vat18Calculation = (Number(amount18) + Number(vat18));

    const totalWithoutVAT = (Number(amount0) + Number(amount8) + Number(amount18));
    const totalVAT = (Number(vat8) + Number(vat18));
    const totali = (Number(totalWithoutVAT) + Number(totalVAT));

    const documentLabel = formType === "kredi" ? "Nota Kreditore" : (formType === "debi" ? "Nota debitore" : "Avans i Pranuar");
    const nr = formType === "kredi" ? invoiceNR : (formType === "debi" ? `DNT-${fiscalYear}-${invoiceNR}` : `ADV-${fiscalYear}-${invoiceNR}`);

    const printStyles = {
        printLogo: {
            display: 'block', // Siguro që logo shfaqet në modalitetin e printimit
        },
    };

    const tableRef = useRef();

    const handlePrint = () => {
        const table = tableRef.current;

        if (!table) {
            console.error("Table reference not found.");
            return;
        }

        // Krijo një dritare të re për printim
        const printWindow = window.open('', 'PrintWindow', 'height=400,width=600');

        if (!printWindow) {
            console.error("Print window could not be opened.");
            return;
        }

        // Vendos përmbajtjen HTML dhe titullin
        printWindow.document.open();
        printWindow.document.write(`
            <html>
            <head>
                <title>Print Table Data</title> <!-- Titulli i dritares -->
                <style>
                    table {
                        width: 100%;
                        border-collapse: collapse;
                    }
                    table, th, td {
                        border: 1px solid black;
                    }
                    th, td {
                        padding: 8px;
                        text-align: left;
                    }
                </style>
            </head>
            <body>
                ${table.outerHTML}
            </body>
            </html>
        `);

        // Siguro që titulli të jetë i ndryshuar
        // printWindow.document.title = (actionType === "IND" || actionType === "PRI" || actionType === "OFR" || actionType === "DND") ? inv : invoiceNr;
        printWindow.document.close();
        // Fokusohu te dritarja e printimit dhe inicio printimin
        printWindow.focus();
        printWindow.print();

        // Opsionale: Mbyll dritaren pas printimit
        printWindow.close();
    };

    useEffect(() => {
        if (barcodeRef.current && invoiceNR?.trim()) {
            const nr = formType === "kredi"
                ? invoiceNR
                : formType === "debi"
                    ? `DNT-${fiscalYear}-${invoiceNR}`
                    : `ADV-${fiscalYear}-${invoiceNR}`;

            JsBarcode(barcodeRef.current, nr, {
                format: "CODE128",
                height: 30,
                width: 1.5,
                text: nr,
                fontSize: 12
            });
        }
    }, [formType, fiscalYear, invoiceNR]);



    return (
        <div>
            <div style={{ display: "none" }}>
                <div className='PrintContent__Container' ref={tableRef} style={{ width: "100%", display: "flex", flexDirection: "column" }}>
                    <div className='PrintContent__Container__div2' style={{ display: "flex", justifyContent: "space-between", paddingLeft: "15px", paddingRight: "15px", height: "auto" }}>
                        <div className='PrintContent__Container__div2__logo' style={{ width: "300px", height: "130px" }}>
                            {(companyData && companyData.length > 0 && companyData[0]?.CompanyLogo) ? (
                                <img src={ApiLink.PHOTO_URL + companyData[0].CompanyLogo} style={{ width: "200px", height: "120px" }} className="printLogo" />
                            ) : (
                                <span>No logo available</span>
                            )}
                        </div>

                        <div className='PrintContent__Container__div2__data' style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", padding: "5px" }}>
                            {
                                formType === "kredi" ? (
                                    <>
                                        <label style={{ fontSize: "12px" }}>
                                            <b>
                                                Kreditori:{" "}
                                                {companyData && companyData.length > 0
                                                    ? companyData[0].CompanyName
                                                    : ""}
                                            </b>
                                        </label>
                                    </>
                                ) : formType === "debi" ? (
                                    <>
                                        <label style={{ fontSize: "12px" }}>
                                            <b>
                                                Debitori:{" "}
                                                {companyData && companyData.length > 0
                                                    ? companyData[0].CompanyName
                                                    : ""}
                                            </b>
                                        </label>
                                    </>
                                ) : formType === "avanc" ? (
                                    <>
                                        <label style={{ fontSize: "12px" }}>
                                            <b>
                                                Pranuesi i Avansit:{" "}
                                                {companyData && companyData.length > 0
                                                    ? companyData[0].CompanyName
                                                    : ""}
                                            </b>
                                        </label>
                                    </>
                                ) :
                                    null
                            }

                            <label style={{ fontSize: "12px" }}>NUI: {companyData && companyData.length > 0 ? (companyData[0].IdentificationNumber) : ''}</label>
                            {
                                companyData && companyData.length > 0 && companyData[0].VATDeclarant != 0 ?
                                    (
                                        <label style={{ fontSize: "12px" }}>Numri i TVSH-së: {companyData[0].VATNumber}</label>
                                    )
                                    :
                                    null
                            }
                            <label style={{ fontSize: "12px" }}>Adresa: {companyData && companyData.length > 0 ? (companyData[0].Address) : ''}</label>
                            <label style={{ fontSize: "12px" }}>Tel: {companyData && companyData.length > 0 ? (companyData[0].PhoneNumbers) : ''}</label>
                            <label style={{ fontSize: "12px" }}>Email: {companyData && companyData.length > 0 ? (companyData[0].Email) : ''}</label>
                        </div>
                    </div>
                    <hr style={{ margin: "10px" }}></hr>

                    <div className='PrintContent__Container__div3' style={{ display: "flex", justifyContent: "space-between", height: "auto" }}>
                        <div className='PrintContent__Container__div3__bleresi' style={{ display: "flex", flexDirection: "column", paddingLeft: "10px" }} >
                            {
                                formType === "kredi" ? (
                                    <>
                                        <label style={{ fontSize: "12px" }}>
                                            <b>
                                                Debitori:{" "}
                                                {clientData && clientData.length > 0
                                                    ? clientData[0].AccountName
                                                    : ""}
                                            </b>
                                        </label>
                                    </>
                                ) : formType === "debi" ? (
                                    <>
                                        <label style={{ fontSize: "12px" }}>
                                            <b>
                                                Kreditori:{" "}
                                                {clientData && clientData.length > 0
                                                    ? clientData[0].AccountName
                                                    : ""}
                                            </b>
                                        </label>
                                    </>
                                ) : formType === "avanc" ? (
                                    <>
                                        <label style={{ fontSize: "12px" }}>
                                            <b>
                                                Dhënësi i Avansit:{" "}
                                                {clientData && clientData.length > 0
                                                    ? clientData[0].AccountName
                                                    : ""}
                                            </b>
                                        </label>
                                    </>
                                ) : null
                            }


                            <label style={{ fontSize: "12px" }}>Numri Unik Identifikues: {clientData && clientData.length > 0 ? (clientData[0].IdentificationNumber) : ''}</label>
                            {
                                clientData && clientData.length > 0 && clientData[0].VATNumber != null ?
                                    <label style={{ fontSize: "12px" }}>Numri i TVSH-së: {clientData && clientData.length > 0 ? (clientData[0].VATNumber) : ''}</label>

                                    :
                                    null

                            }

                            {
                                clientData && clientData.length > 0 && clientData[0].ClientBranchName != null ?
                                    <>
                                        <label style={{ fontSize: "12px" }}>Njësia: {clientData && clientData.length > 0 ? (clientData[0].ClientBranchName) : ''}</label>
                                        <label style={{ fontSize: "12px" }}>Adresa njësisë: {clientData && clientData.length > 0 ? (clientData[0].ClientBranchAddress) : ''}</label>
                                    </>
                                    :
                                    <>
                                        <label style={{ fontSize: "12px" }}>Qyteti: {clientData && clientData.length > 0 ? (clientData[0].cityName) : ''}</label>
                                        <label style={{ fontSize: "12px" }}>Adresa: {clientData && clientData.length > 0 ? (clientData[0].Adress) : ''}</label>
                                    </>
                            }
                            <label style={{ fontSize: "12px" }}>tel: {clientData && clientData.length > 0 ? (clientData[0].PhoneNumbers) : ''}</label>
                        </div>
                        <div className='PrintContent__Container__div3__dokumenti' style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", paddingRight: "10px" }} >
                            <label style={{ fontSize: "12px" }}>
                                <b>Dokumenti: {documentLabel}</b>
                            </label>

                            <label style={{ fontSize: "12px" }}> <b>Numri: </b>
                                <label style={{ fontSize: "12px" }}>
                                    <b>
                                        {nr}
                                    </b>
                                </label>
                            </label>
                            <label style={{ fontSize: "12px" }}>
                                <b>Data Faturës:{" "}
                                    {formatDate(date)}
                                </b>
                            </label>
                            <label style={{ fontSize: "12px" }}>Përdoruesi:    {user.split('@')[0]}</label>
                            {/* <label style={{ fontSize: "12px" }}>Njesia Organizative: {props.details.length > 0 && props.details[0].UnitName ? props.details[0].UnitName : ''}</label> */}
                        </div>
                    </div>
                    <hr style={{ margin: "10px" }}></hr>

                    <div className='PrintContent__Container__div4' style={{ paddingLeft: "10px", display: "flex", justifyContent: "space-between" }}>
                        <div>
                        </div>

                        <div>
                            <svg ref={barcodeRef}></svg>
                        </div>
                    </div>
                    <hr style={{ margin: "10px" }}></hr>

                    <div className='PrintContent__Container__div5' style={{ paddingLeft: "10px", height: "30px" }}>
                        <div className='PrintContent__Container__div5__MainTable'>
                            <table className='PrintTable' style={{ width: "100%", borderCollapse: "collapse" }}>
                                <tbody>
                                    <tr style={{ borderBottom: "1px solid black " }}>
                                        <th className='TableHeader' style={{ padding: "8px", textAlign: "ce", border: "solid black 1px", backgroundColor: "lightgray", fontSize: "10px", width: "300px" }}>Përshkrimi i notës</th>
                                    </tr>
                                    <tr>
                                        <td style={{ padding: "3px", textAlign: "left", border: "1px solid black", fontSize: "10px", width: "300px" }}>{comment}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <br></br>
                        {
                            companyData && companyData.length > 0 && companyData[0].VATDeclarant != 0 ?
                                (
                                    <div className='PrintContent__Container__div5__SecondTable' style={{ display: "flex", justifyContent: "space-between" }}>
                                        <table className='PrintTable' style={{ width: "50%", borderCollapse: "collapse" }}>
                                            <tbody>
                                                <tr style={{ borderBottom: "1px solid black " }}>
                                                    <th className='TableHeader' style={{ padding: "8px", textAlign: "left", border: "solid black 1px", backgroundColor: "lightgray", fontSize: "10px", textAlign: "center" }}>Norma Tatimore</th>
                                                    <th className='TableHeader' style={{ padding: "8px", textAlign: "left", border: "solid black 1px", backgroundColor: "lightgray", fontSize: "10px", textAlign: "center" }}>Baza</th>
                                                    <th className='TableHeader' style={{ padding: "8px", textAlign: "left", border: "solid black 1px", backgroundColor: "lightgray", fontSize: "10px", textAlign: "center" }}>TVSH</th>
                                                    <th className='TableHeader' style={{ padding: "8px", textAlign: "left", border: "solid black 1px", backgroundColor: "lightgray", fontSize: "10px", textAlign: "center" }}>Total</th>
                                                </tr>
                                                <tr style={{ borderBottom: "1px solid black " }}>
                                                    <td style={{ padding: "3px", textAlign: "left", border: "1px solid black", fontSize: "10px" }}>TVSH e llogaritur (A) 0%:</td>
                                                    <td style={{ padding: "3px", textAlign: "left", border: "1px solid black", textAlign: "right", fontSize: "10px" }}>
                                                        {(Number(amount0) || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })} €
                                                    </td>
                                                    <td style={{ padding: "3px", textAlign: "left", border: "1px solid black", textAlign: "right", fontSize: "10px" }}>{(0).toFixed(2)} €</td>
                                                    <td style={{ padding: "3px", textAlign: "left", border: "1px solid black", textAlign: "right", fontSize: "10px" }}>
                                                        {(Number(amount0) || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })} €
                                                    </td>
                                                </tr>

                                                <tr style={{ borderBottom: "1px solid black " }}>
                                                    <td style={{ padding: "3px", textAlign: "left", border: "1px solid black", fontSize: "10px", width: "150px" }}>TVSH e llogaritur (D) 8%:</td>
                                                    <td style={{ padding: "3px", textAlign: "left", border: "1px solid black", textAlign: "right", fontSize: "10px" }}>
                                                        {(Number(amount8) || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })} €
                                                    </td>
                                                    <td style={{ padding: "3px", textAlign: "left", border: "1px solid black", textAlign: "right", fontSize: "10px" }}>
                                                        {(Number(vat8) || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })} €
                                                    </td>
                                                    <td style={{ padding: "3px", textAlign: "left", border: "1px solid black", textAlign: "right", fontSize: "10px" }}>
                                                        {(Number(vat8Calculation) || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })} €
                                                    </td>
                                                </tr>
                                                <tr style={{ borderBottom: "1px solid black " }}>
                                                    <td style={{ padding: "3px", textAlign: "left", border: "1px solid black", fontSize: "10px" }}>TVSH e llogaritur (E) 18%:</td>
                                                    <td style={{ padding: "3px", textAlign: "left", border: "1px solid black", textAlign: "right", fontSize: "10px" }}>
                                                        {(Number(amount18) || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })} €
                                                    </td>

                                                    <td style={{ padding: "3px", textAlign: "left", border: "1px solid black", textAlign: "right", fontSize: "10px" }}>
                                                        {(Number(vat18) || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })} €
                                                    </td>
                                                    <td style={{ padding: "3px", textAlign: "left", border: "1px solid black", textAlign: "right", fontSize: "10px" }}>
                                                        {(Number(vat18Calculation) || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })} €
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table className='PrintTable' style={{ width: "40%", borderCollapse: "collapse" }}>
                                            <tbody>
                                                <tr style={{ borderBottom: "1px solid black " }}>
                                                    <td style={{ padding: "3px", textAlign: "left", border: "1px solid black", fontSize: "10px" }}>Total pa TVSH:</td>
                                                    <td style={{ padding: "3px", textAlign: "left", border: "1px solid black", textAlign: "right", fontSize: "10px" }}>
                                                        {totalWithoutVAT !== null && totalWithoutVAT !== 0 ? totalWithoutVAT.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00'} €
                                                    </td>
                                                </tr>
                                                <tr style={{ borderBottom: "1px solid black " }}>
                                                    <td style={{ padding: "3px", textAlign: "left", border: "1px solid black", fontSize: "10px" }}>Total TVSH:</td>
                                                    <td style={{ padding: "3px", textAlign: "left", border: "1px solid black", textAlign: "right", fontSize: "10px" }}>
                                                        {totalVAT !== null && totalVAT !== 0 ? totalVAT.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00'} €
                                                    </td>
                                                </tr>
                                                <tr style={{ borderBottom: "1px solid black " }}>
                                                    <th className='TableHeader' style={{ padding: "8px", textAlign: "left", border: "solid black 1px", backgroundColor: "lightgray", fontSize: "10px" }}>Totali</th>
                                                    <th className='TableHeader' style={{ padding: "8px", textAlign: "left", border: "solid black 1px", backgroundColor: "lightgray", textAlign: "right", fontSize: "10px" }}>
                                                        {totali !== null && totali !== 0 ? totali.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00'} €
                                                    </th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                ) :
                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                    <div style={{ width: "70%" }}>
                                    </div>
                                    <div >
                                        <table className='PrintTable' style={{ display: "flex", justifyContent: "flex-end" }}>
                                            <tbody>
                                                <tr >
                                                    <th className='TableHeader' style={{ padding: "8px", textAlign: "left", border: "solid black 1px", backgroundColor: "lightgray", fontSize: "10px" }}>Totali</th>
                                                    <th className='TableHeader' style={{ padding: "8px", textAlign: "left", border: "solid black 1px", backgroundColor: "lightgray", textAlign: "right", fontSize: "10px" }}>
                                                        {/* {(props.details && props.details.length > 0 ? (props.details[0].Total) : 0).toFixed(2)} € */}
                                                        {totali !== null && totali !== 0 ? totali.toLocaleString('en-US', { minimumFractionDigits: 2 }) : '0.00'} €
                                                    </th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                        }
                        <div className='PrintContent__Container__div6' style={{ paddingTop: "10px" }}>
                            <p style={{ fontSize: "12px" }}>Ju faleminderit për bashkëpunimin tuaj!</p>
                        </div>
                        <div style={{ position: "fixed", bottom: 0, width: "99%", backgroundColor: "white" }}>
                            <div className='PrintContent__Container__div7' style={{ display: "flex", justifyContent: "space-evenly", paddingTop: "50px", paddingRight: "15px", }}>
                                {
                                    printElectronicSeal ?
                                        <>
                                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                <div style={{ border: "solid 1px blue", display: "flex", flexDirection: "column", alignItems: "center", paddingLeft: "10px", paddingRight: "10px" }}>
                                                    <label style={{ color: "blue", fontSize: "11px" }}>{companyData && companyData.length > 0 ? (companyData[0].CompanyName) : ''}</label>
                                                    <label style={{ color: "green", fontSize: "11px" }}>Konfirmuar</label>
                                                    <label style={{ color: "blue", fontSize: "11px" }}>VULA ELEKTRONIKE</label>
                                                </div>
                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                    <label style={{ color: "blue", marginBottom: "-15px", fontSize: "12px" }}>
                                                        {user && user.length > 0 && user
                                                            ? user.split('@')[0]
                                                            : ''}
                                                    </label>
                                                    <span>_________________________</span>
                                                    <label style={{ fontSize: "10px" }}>Faturoi:</label>
                                                </div>
                                            </div>
                                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", paddingTop: "39px" }}>
                                                <span>_________________</span>
                                                <label style={{ fontSize: "10px" }}>Dergoi:</label>
                                            </div>
                                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", paddingTop: "39px" }}>
                                                <span>_________________</span>
                                                <label style={{ fontSize: "10px" }}>Pranoi:</label>
                                            </div>
                                        </>
                                        :
                                        < >
                                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                <span>_________________</span>
                                                <label style={{ fontSize: "10px" }}>Faturoi:</label>
                                            </div>
                                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                <span>_________________</span>
                                                <label style={{ fontSize: "10px" }}>Dergoi:</label>
                                            </div>
                                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                <span>_________________</span>
                                                <label style={{ fontSize: "10px" }}>Pranoi:</label>
                                            </div>
                                        </>
                                }
                            </div>

                            <div className='PrintContent__Container__div8' style={{ paddingTop: "5px", paddingRight: "15px", }}>
                                <br></br>
                                <table className='PrintTable' style={{ borderCollapse: "collapse", borderTop: "1px solid black" }}>
                                    <thead>
                                        <tr style={{ borderBottom: "1px solid black ", backgroundColor: "lightgray" }}>
                                            <th style={{ padding: "8px", textAlign: "left", backgroundColor: "lightgray", fontSize: "10px" }}>Banka</th>
                                            <th style={{ padding: "8px", textAlign: "left", backgroundColor: "lightgray", fontSize: "10px" }}>Emri Llogaris</th>
                                            <th style={{ padding: "8px", textAlign: "left", backgroundColor: "lightgray", fontSize: "10px" }}>Numri Llogaris</th>
                                            <th style={{ padding: "8px", textAlign: "left", backgroundColor: "lightgray", fontSize: "10px" }}>Swift Kodi</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {bankaccounts &&
                                            bankaccounts.map((data) => (
                                                <tr style={{ borderBottom: "1px solid black ", fontSize: "10px" }} key={data.AccountID}>
                                                    <td style={{ padding: "3px", textAlign: "left", fontSize: "10px" }}>{data.BankName}</td>
                                                    <td style={{ padding: "3px", textAlign: "left", fontSize: "10px" }}>{companyData.length > 0 && companyData[0].CompanyName ? companyData[0].CompanyName : ''}</td>
                                                    <td style={{ padding: "3px", textAlign: "left", fontSize: "10px" }}>{data.IBAN + " " + data.IdentificationNumber}</td>
                                                    <td style={{ padding: "3px", textAlign: "left", fontSize: "10px" }}>{data.SWIFT}</td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                                <label style={{ width: "100%", fontSize: "10px", display: "flex", justifyContent: "flex-end" }}><b>© Quantify Nexus L.L.C | www.accountree.net</b></label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <button className="button-15" variant="contained" onClick={handlePrint}><FaPrint /> Print</button> */}
            <AddActionsButton
                text="Print"
                onClick={handlePrint}
                icon={<FaPrint />}
                className="button-15"
            />
        </div>
    );
};

export default PrintCreditNote;
